
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('filter',{attrs:{"id":"a"}},[_c('feColorMatrix',{attrs:{"in":"SourceGraphic","values":"0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"}})])]),_c('g',{attrs:{"filter":"url(#a)","transform":"translate(-8 -8)","fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#252626","d":"M17 17.75l-3-5.17a.52.52 0 01.13-.66A10.005 10.005 0 0120 10c.492.001.983.038 1.47.11a.501.501 0 01.35.74l-4 6.9a.501.501 0 01-.82 0zm3.87-.75h8c.163 0 .316-.08.41-.213a.502.502 0 00.06-.457 10 10 0 00-5.25-5.46.49.49 0 00-.63.21l-3 5.17a.499.499 0 00.41.75zM13 13.86a.488.488 0 00-.386-.25.487.487 0 00-.424.18A9.906 9.906 0 0010 20c.003.354.026.708.07 1.06a.49.49 0 00.5.44h6a.499.499 0 00.43-.75l-4-6.89zM19.13 23h-8a.503.503 0 00-.41.213.502.502 0 00-.06.457A10.002 10.002 0 0016 29.13a.49.49 0 00.63-.21l3-5.17a.499.499 0 00-.5-.75zM27 26.14c.08.143.224.237.386.25a.487.487 0 00.424-.18A9.906 9.906 0 0030 20a9.173 9.173 0 00-.07-1.06.49.49 0 00-.5-.44h-6a.499.499 0 00-.43.75l4 6.89zm-4.84-3.89l-4 6.9a.5.5 0 00.35.74 9.999 9.999 0 007.38-1.81.52.52 0 00.13-.66l-3-5.17a.5.5 0 00-.85 0h-.01z"}})])])
          )
        }
      }
    